import PropTypes from 'prop-types';
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons/faCircleCheck';

import classNames from 'classnames/bind';
import styles from './styles.module.scss';
import ProgressBarIcon from './ProgressBarIcon';

const cx = classNames.bind(styles);

const ProgressBar = props => {
  const { active, activePhaseText, minFilled, maxFilled, iconHeight, minPhaseText, maxPhaseText } =
    props;

  return (
    <div className={cx('progressBarContainer')}>
      <div className="row col-11 col-xl-12 m-1 pr-0">
        <div className={cx('absoluteFill')} />
        <div
          className={cx('progressBar', minFilled && cx('minSize'), maxFilled && cx('maxSize'))}
        />
        <ProgressBarIcon
          className={cx('iconLeft')}
          colorScheme={active ? 'primary' : 'gray'}
          icon={faCircleCheck}
          size={iconHeight}
        />
        <ProgressBarIcon
          className={cx('iconCenter')}
          colorScheme={minFilled || maxFilled ? 'primary' : 'gray'}
          icon={faCircleCheck}
          size={iconHeight}
        />
        <ProgressBarIcon
          className={cx('iconRight')}
          colorScheme={maxFilled ? 'primary' : 'gray'}
          icon={faCircleCheck}
          size={iconHeight}
        />
      </div>
      <div className={cx('phases', 'p-2')}>
        <span className={active ? cx('active') : cx('text')}>{activePhaseText}</span>
        <span className={minFilled || maxFilled ? cx('active') : cx('text')}>{minPhaseText}</span>
        <span className={maxFilled ? cx('active') : cx('text')}>{maxPhaseText}</span>
      </div>
    </div>
  );
};

ProgressBar.propTypes = {
  active: PropTypes.bool,
  minFilled: PropTypes.bool,
  maxFilled: PropTypes.bool,
  iconHeight: PropTypes.string,
  activePhaseText: PropTypes.string,
  minPhaseText: PropTypes.string,
  maxPhaseText: PropTypes.string,
};
ProgressBar.defaultProps = {
  active: false,
  minFilled: false,
  maxFilled: false,
  iconHeight: '10px',
  activePhaseText: '',
  minPhaseText: '',
  maxPhaseText: '',
};

export default ProgressBar;
